import { ChangeEvent } from 'react';
import styles from '../../docxTemplateWidget.module.css';

interface TextFieldSectionProps {
    title: string;
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    rows?: number;
}

export default function TextFieldSection({
    title,
    value,
    onChange,
    placeholder = "Enter text here...",
    rows = 4
}: TextFieldSectionProps) {
    const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        onChange(e.target.value);
    };

    return (
        <div className={styles.section}>
            <h3 className={styles.sectionTitle}>{title}</h3>
            <textarea
                className={styles.textarea}
                value={value || ""}
                onChange={handleChange}
                placeholder={placeholder}
                rows={rows}
            />
        </div>
    );
} 